import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    template: '',
})
export class FieldBaseComponent {
    @Input() controlName: string;
    @Input() parentForm: UntypedFormGroup;

    get inputControl() {
        if (this.controlName) {
            return this.parentForm?.get(this.controlName);
        }
    }
}
